var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketplaceCreatorCardExternalLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83357 5.1665C6.36081 5.1665 5.1669 6.36041 5.1669 7.83317V15.4998C5.1669 16.9726 6.36081 18.1665 7.83357 18.1665H15.5002C16.973 18.1665 18.1669 16.9726 18.1669 15.4998V14.5415C18.1669 14.1273 17.8311 13.7915 17.4169 13.7915C17.0027 13.7915 16.6669 14.1273 16.6669 14.5415V15.4998C16.6669 16.1442 16.1446 16.6665 15.5002 16.6665H7.83357C7.18924 16.6665 6.6669 16.1442 6.6669 15.4998V7.83317C6.6669 7.18884 7.18924 6.6665 7.83357 6.6665H8.7919C9.20611 6.6665 9.5419 6.33072 9.5419 5.9165C9.5419 5.50229 9.20611 5.1665 8.7919 5.1665H7.83357Z",
    fill: "#909A9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.947 6.44683C18.2399 6.15394 18.2399 5.67907 17.947 5.38617C17.6541 5.09328 17.1792 5.09328 16.8863 5.38617L12.0947 10.1778C11.8018 10.4707 11.8018 10.9456 12.0947 11.2385C12.3876 11.5314 12.8624 11.5314 13.1553 11.2385L17.947 6.44683Z",
    fill: "#909A9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5838 5.1665C13.1696 5.1665 12.8338 5.50229 12.8338 5.9165C12.8338 6.33072 13.1696 6.6665 13.5838 6.6665H16.6671V9.74984C16.6671 10.1641 17.0029 10.4998 17.4171 10.4998C17.8313 10.4998 18.1671 10.1641 18.1671 9.74984V5.9165V5.1665H17.4171H13.5838Z",
    fill: "#909A9C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceCreatorCardExternalLink);
export default __webpack_public_path__ + "static/media/marketplace-creator-card-external-link.589d3f97559f6bb9c6189a2bafe2afad.svg";
export { ForwardRef as ReactComponent };